const sections = {
  Orders: {
    value: 'ORDERS',
    label: 'adminPanel.details.orders'
  },
  CarrierEmails: {
    value: 'CARRIER_EMAILS',
    label: 'adminPanel.details.carrierEmails'
  },Dummy: {
    value: 'DUMMY',
    label: 'adminPanel.details.orders'
  }
}
export default sections
